import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import Panel from '../../../../theme/components/Panel';
import Alert from '../../../../theme/components/Alert';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {Store} from 'react-redux';
import {ACCESS_TOKEN} from '../../../../utils/constants';
import MiranaState from '../../../../reduxstore/mirana-state';
import {FilePond} from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import fileDownload from 'js-file-download';
import {error} from '../../../../utils/notification-actions';
import {getFileName} from '../../../../utils/utils';

interface IState {
    error?: string
}

class TiendaPagoConf extends React.Component<RouteComponentProps<any>, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {};
    }

    private descargarPlantilla = async () => {
        try {
            const response = await this.apiClient.descargarPlantillaTiendaPago();
            fileDownload(response.data, getFileName(response));
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error interno al generar plantilla para tienda pago'));
        }
    };

    private get mensajesError() {
        const content = [] as any;
        if (this.state.error) {
            const errors = this.state.error.split('<br/>');
            errors.forEach((er) => {
                content.push(<Alert color='danger' className='alert--bordered' icon={true} visible={true}>
                    <p><span className='bold-text'>Error:</span> {er}</p>
                </Alert>)
            });
        }
        return content;
    }


    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Actualizar Tienda Pago</h3>
                    </Col>
                    <Col md={6} lg={6}>
                        <Panel xs={12} md={12} divider={true} title='Actualizar tienda pago'>
                            <h4 className='subhead' style={{marginBottom: '17px'}}>Descargar plantilla <a
                                onClick={this.descargarPlantilla} href='#'>aquí</a></h4>
                            {/* En el futuro este componente debe ser movido a un solo archivo*/}
                            <FilePond
                                acceptedFileTypes={['.csv']}
                                allowRevert={false}
                                name='files'
                                labelFileProcessingComplete='Carga completada'
                                labelFileProcessing='Subiendo'
                                labelTapToCancel='Presiona para cancelar'
                                labelTapToRetry='Presiona para reintentar'
                                labelFileProcessingError='Error al cargar archivo'
                                onprocessfile={(error) => {
                                    if (!error) {
                                        this.setState({error: undefined})
                                    }
                                }}
                                server={{
                                    url: `${process.env.REACT_APP_API_URL}/api/prioritarios/tiendapago`,
                                    process: {
                                        headers: {
                                            'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN)
                                        },
                                        onerror: (error) => {
                                            const errorBody = JSON.parse(error) as any;
                                            if (errorBody.message) {
                                                this.setState({error: errorBody.message})
                                            }
                                        }
                                    }
                                }}

                                fileValidateTypeDetectType={(file) => {
                                    return new Promise((resolve, reject) => {
                                        if (file.name.substr(file.name.length - 4, 4) === '.csv') {
                                            resolve('.csv');
                                        } else {
                                            reject();
                                        }
                                    });
                                }}
                                labelIdle='Suelta tus archivos aquí <span class="filepond--label-action"> Buscar </span>'/>
                            {this.mensajesError}
                        </Panel>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(TiendaPagoConf);


// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/tiendapago/tienda-pago-conf.tsx